// @ts-nocheck
import { Box } from "@mui/material";
import { SignOut } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../providers/AuthProvider";
import SidenavFooterButton from "./SidenavFooterButton";

export default function LogoutButton() {
  const { logout } = useAuth();
  const { t } = useTranslation();

  return (
    <Box
      onClick={logout}
      sx={{
        textDecoration: "none",
        color: "black",
        "&:hover": { bgcolor: "primary.light", color: "primary.main" },
      }}
    >
      <SidenavFooterButton Icon={SignOut} children={t("auth.logout")} />
    </Box>
  );
}
